import { cn as m } from "../../../lib/shadcn/utils/utils.js";
import { FormsKeys as I } from "../../../i18n/translations/types/forms.js";
import { Namespace as M } from "../../../i18n/translations/types/namespaces.js";
import { FloatingLabel as ee } from "../../../lib/shadcn/ui/components/floating-input.js";
import { handleValidation as A } from "../../../helpers/validation.helper.js";
import { NativeSelect as te, NativeSelectOption as C } from "../../../lib/shadcn/ui/components/native-select.js";
import { memo as ae, useEffect as N, useMemo as O, useRef as re, useState as B } from "react";
import { jsx as n, jsxs as S } from "react/jsx-runtime";
import { useTranslation as G } from "react-i18next";
import { v4 as oe } from "uuid";
var K = ({ id: L, dataTestid: k, label: F, startIcon: i, name: o, hint: V, disabled: c, hideOptionalLabel: z, highlight: g, invalid: E, errorMessage: a, required: f, options: u, children: r, value: t, defaultValue: D, className: H, classNames: s, namespaces: J, validator: P, onValueChange: Q, validateTrigger: _, resetTrigger: $, onValidateResult: d, ref: R, ...T }) => {
  const { t: y } = G(J), { t: x } = G(M.Forms), b = re(L || o || `select-${oe()}`), [p, v] = B(a ? { message: a } : void 0), [l, j] = B(() => t ?? D ?? ""), U = f || z ? "" : ` (${x(I.General_Optional)})`, w = O(() => c ? "disabled" : p || a || E ? "invalid" : g ? "highlight" : "default", [
    p,
    a,
    E,
    g,
    c
  ]);
  N(() => {
    t != null && j(t);
  }, [t]), N(() => {
    if (_) {
      const e = A({
        t: x,
        validator: P,
        value: t || "",
        extraProps: { required: f }
      });
      v(e.isValid ? void 0 : { message: e.error }), d && d(e.isValid);
    }
  }, [_, d]), N(() => {
    $ && v(void 0);
  }, [$]);
  const W = (e) => {
    const h = e.target.value;
    j(h);
    const { isValid: Z, error: q } = A({
      t: x,
      validator: P,
      value: h,
      extraProps: { required: f }
    });
    v(Z ? void 0 : { message: q }), Q?.(h);
  }, X = l === void 0 || l === "" || l === null, Y = O(() => [
    /* @__PURE__ */ n(C, {
      value: "",
      hidden: !0
    }, "__empty"),
    ...r ? Array.isArray(r) ? r : [r] : [],
    ...u?.map ? u.map((e) => /* @__PURE__ */ n(C, {
      value: e.value,
      children: y(e.label)
    }, e.value)) : []
  ], [
    u,
    r,
    y
  ]);
  return /* @__PURE__ */ S("div", {
    className: m("flex w-full flex-col gap-0", s?.root),
    children: [
      /* @__PURE__ */ S(te, {
        ref: R,
        id: b.current,
        "data-testid": k,
        "data-qa-ta": `select-${o}`,
        "aria-label": o,
        name: o,
        disabled: c,
        variant: w,
        className: H,
        onChange: W,
        value: l,
        startIcon: i,
        "data-empty": X ? "true" : "false",
        ...T,
        children: [F && /* @__PURE__ */ S(ee, {
          htmlFor: b.current,
          variant: w,
          iconPosition: i ? "start" : "default",
          className: m("pointer-events-none right-10", i ? "left-12" : "left-4", "peer-data-[empty=true]:!top-4.5 peer-data-[empty=true]:!translate-y-0 peer-data-[empty=true]:!scale-100 peer-data-[empty=true]:!text-[16px]", "peer-data-[empty=false]:!top-5.5 peer-data-[empty=false]:!-translate-y-4 peer-data-[empty=false]:!scale-100 peer-data-[empty=false]:!text-sm", "peer-focus:!top-5.5 peer-focus:!-translate-y-4 peer-focus:!scale-100 peer-focus:!text-sm", "peer-focus:peer-data-[empty=true]:!top-5.5 peer-focus:peer-data-[empty=true]:!-translate-y-4 peer-focus:peer-data-[empty=true]:!scale-100 peer-focus:peer-data-[empty=true]:!text-sm", s?.label),
          children: [F, U]
        }), Y]
      }),
      (a || p?.message) && /* @__PURE__ */ n("span", {
        className: m("mt-1 px-2 text-sm text-error-700", s?.errorMessage),
        children: y(a || p?.message || "")
      }),
      V && /* @__PURE__ */ n("span", {
        className: m("mt-1 px-2 text-sm text-secondary-600", s?.hint),
        children: V
      })
    ]
  });
};
K.displayName = "Select";
var se = ae(K);
se.displayName = "Select";
export {
  se as Select
};

//# sourceMappingURL=Select.js.map